module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-fade",
      "appear": ""
    }
  }, [(!_vm.isHidden) ? _c('div', {
    staticClass: "form-group col-sm-4"
  }, [_c('div', {
    staticClass: "items-container",
    class: [this.iconClass, {
      'enabled-container': _vm.showClickable
    }, {
      'color-gray': !_vm.showClickable
    }],
    on: {
      "click": _vm.clickedOnButton
    }
  }, [_c('div', {
    staticClass: "button-text-background"
  }, [_c('div', {
    staticClass: "button-text-container"
  }, [_c('span', {
    staticClass: "button-text"
  }, [_vm._v(_vm._s(_vm.$t(this.text)))])])])])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f417e640", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f417e640","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Homepage/homepageGridButton.vue
// module id = 2463
// module chunks = 2